export const lineShapeTypeIcon = {
  name: 'line-shape-type',
  svg: `<svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M20.2105 2.52631C19.5129 2.52631 18.9474 3.09185 18.9474 3.78947C18.9474 4.48709 19.5129 5.05263 20.2105 5.05263C20.9081 5.05263 21.4737 4.48709 21.4737 3.78947C21.4737 3.09185 20.9081 2.52631 20.2105 2.52631ZM17.6842 3.78947C17.6842 2.39422 18.8153 1.26315 20.2105 1.26315C21.6058 1.26315 22.7368 2.39422 22.7368 3.78947C22.7368 5.18471 21.6058 6.31578 20.2105 6.31578C18.8153 6.31578 17.6842 5.18471 17.6842 3.78947Z'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M3.7895 18.9474C3.09188 18.9474 2.52634 19.5129 2.52634 20.2105C2.52634 20.9081 3.09188 21.4737 3.7895 21.4737C4.48712 21.4737 5.05266 20.9081 5.05266 20.2105C5.05266 19.5129 4.48712 18.9474 3.7895 18.9474ZM1.26318 20.2105C1.26318 18.8153 2.39425 17.6842 3.7895 17.6842C5.18474 17.6842 6.31581 18.8153 6.31581 20.2105C6.31581 21.6058 5.18474 22.7368 3.7895 22.7368C2.39425 22.7368 1.26318 21.6058 1.26318 20.2105Z'
      \\
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M18.034 5.07285C18.2514 5.4407 18.5594 5.74867 18.9272 5.96603L5.96606 18.9272C5.7487 18.5593 5.44073 18.2514 5.07288 18.034L18.034 5.07285Z'
    />
  </svg>`,
};
